import { request } from "../utils/request.js"

export const printer_findPageForManage = (pojo, args) => request({
    url: 'printer/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: false,
    ...args
})

export const printer_getSecretKey = (id, args) => request({
    url: 'printer/getSecretKey',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const printer_resetSecretKey = (pojo, args) => request({
    url: 'printer/resetSecretKey',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const printer_checkOnline = ( args) => request({
    url: 'printer/checkOnline',
    method: 'GET',
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})




// WEBPACK FOOTER //
// ./src/api/printer.js